import React from "react";
import { TypedToolInvocation } from "../utils";
import { CheckCircleIcon, FileTextIcon } from "lucide-react";
import Spinner from "../../../../components/ui/spinner";

export function ApplyPlanChangesToolInvocation({
    invocation,
}: {
    invocation: TypedToolInvocation<"applyPlanChanges">;
}) {
    const result = invocation.result;
    const isLoading = invocation.state !== "result";

    if (isLoading) {
        return (
            <div className="flex flex-row items-center gap-3 rounded-md border bg-accent p-2 px-4 text-sm font-medium">
                <Spinner className="h-5 w-5" />
                <span>Applying plan changes...</span>
            </div>
        );
    }

    if (!result) return null;

    const hasStaleDocuments = result.staleDocuments && result.staleDocuments.count > 0;

    return (
        <div className="flex flex-col gap-3 rounded-md border border-confirmation bg-confirmation/20 p-3 px-4 text-sm">
            <div className="flex items-center gap-3 font-medium">
                <CheckCircleIcon className="h-5 w-5 shrink-0 text-confirmation" />
                <span>Plan changes applied successfully</span>
            </div>

            {hasStaleDocuments && (
                <div className="flex flex-col gap-2 border-t border-confirmation/30 pt-3">
                    <div className="flex items-center gap-2 text-muted-foreground">
                        <FileTextIcon className="h-4 w-4" />
                        <span>{result.staleDocuments!.count} documents may need updates:</span>
                    </div>
                    <ul className="ml-6 flex flex-col gap-2">
                        {result.staleDocuments!.documents.map((doc) => (
                            <li key={doc.id}>
                                <div className="font-medium">{doc.name}</div>
                                <div className="text-xs text-muted-foreground">{doc.reason}</div>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}
